<template>
  <div class="main">
    <mt-header fixed :title="$t('选择证件类型')" class="dl_header_white">
      <mt-button icon="back" slot="left" @click="$router.back()"></mt-button>
    </mt-header>
    <div class="container">
      <div class="top">
        <img src="@/assets/img/index/img_beifen_fzhujici.png" />
        <h5>{{ $t("请选择您的证件的颁发国家") }}</h5>
      </div>
      <div class="list">
        <mt-button
          v-for="(item, index) in list"
          :key="index"
          type="primary"
          @click="goWhere(index)"
          >{{ $t(item.name) }}</mt-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { faceIdCard } from "@/utils/index";
import { Toast } from "mint-ui";
export default {
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      list: [
        {
          name: "韩国",
        },
        {
          name: "日本",
        },
        {
          name: "其他",
        },
      ],
    };
  },
  methods: {
    goWhere: function (index) {
      if (index === 0) this.$router.push("/levelThreeApplyKR");
      else if (index === 1) this.$router.push("/levelThreeApplyJP");
      else this.$router.push("/levelThreeApply");
    },
    faceIdCardResult: function (res) {
      Toast(res.toString());
    },
  },
  created() {
    window.faceIdCardResult = this.faceIdCardResult;
  },
  computed: {},
  watch: {
    "$store.state.userInfo": function (val, oldVal) {},
  },
  activated: function () {},
};
</script>

<style scoped>
.main {
  padding-top: 40px;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.container {
  padding: 50px 10px 10px 10px;
}
.top {
  padding: 30px;
  text-align: center;
}
.top img {
  width: 150px;
  margin-bottom: 20px;
}
.list {
  box-sizing: border-box;
}
.list button {
  display: block;
  width: 90%;
  margin: 5%;
  box-sizing: border-box;
}
</style>
